import { theme } from 'theme/mainTheme';

export const folderTypes = {
  latest: 'ostatnie',
  all: '/',
  documents: 'dokumenty',
  images: 'zdjęcia',
  audio: 'muzyka',
  videos: 'wideo',
};

export const documentTypes = [
  'application/x-abiword',
  'application/x-freearc',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.oasis.opendocument.presentation',
  'application/vnd.oasis.opendocument.spreadsheet',
  'application/vnd.oasis.opendocument.text',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/msword',
  'application/epub+zip',
  'text/html',
  'text/javascript',
  'application/json',
  'text/javascript',
  'application/pdf',
  'application/xml',
  'text/xml',
  'text/plain',
  'text/rtf',
];

export const imageTypes = [
  'image/bmp',
  'image/gif',
  'image/vnd.microsoft.icon',
  'image/jpeg',
  'image/png',
  'image/svg+xml',
  'image/tiff',
  'image/webp',
];
export const videoTypes = [
  'video/mpeg',
  'video/x-msvideo',
  'video/ogg',
  'video/mp2t',
  'video/webm',
  'video/3gpp',
  'video/3gpp2',
];

export const audioTypes = [
  'audio/aac',
  'audio/midi',
  'audio/x-midi',
  'audio/mpeg',
  'audio/ogg',
  '	audio/opus',
  'audio/wav',
  'audio/webm',
  'audio/3gpp',
  'audio/3gpp2',
];

export const customStyles = {
  container: (provided) => ({
    ...provided,
    width: '100%',
  }),
  control: (provided) => ({
    ...provided,
    backgroundColor: theme.gray4,
    borderColor: theme.gray3,

    '&:hover': {
      borderColor: theme.gray2,
    },
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: theme.gray4,
    borderRadius: 10,
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? theme.blue : theme.gray4,
    '&:hover': {
      backgroundColor: theme.gray3,
    },
  }),
  input: (provided) => ({
    ...provided,
    color: theme.text,
  }),
  singleValue: (provided) => ({
    ...provided,
    color: theme.text,
  }),
};

export const options = [
  {
    value: '',
    label: 'Brak',
  },
  {
    value: 'lecture',
    label: 'Wykład',
  },
  {
    value: 'exercise',
    label: 'Ćwiczenia',
  },
  {
    value: 'lab',
    label: 'Laboratorium',
  },
];
